const Routes_gral = {
    login: '/',
    home: '/Home',
    user: '/User',
    provider: '/Provider',
    group: '/Group',
    product: '/Product',
    addReq: '/addReq',
    ctaCorriente: '/ctaCorriente',
    pagosYreten: '/pagosYreten',
    solicitudes: '/solicitudes',
    validDatos: '/validDatos',
    subcuentas: '/subcuentas',
    abms: '/abms',
    globalSettings: '/globalSettings',
}

export default Routes_gral